<script setup lang="ts">
import type { Image } from 'sanity';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    image?: Image
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  image: props.block?.image,
}));

</script>

<template>
    <component :is="props.config?.innerComponent" v-bind="data" />
</template>